import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ContextMenuService } from '../../../base/src/abcContextMenu/abcContextMenuService';

@Component({
    selector: 'matContextMenu',
    template: `<span class="contextMenu-style" contentEditable="true" [matMenuTriggerFor]="contextMenu">
      <mat-menu
        #contextMenu="matMenu"
        [style.left]="contextMenuPosition.x"
        [style.top]="contextMenuPosition.y"
        [overlapTrigger]="false"
        >
        @for (item of source; track item) {
          <span>
            <!-- Handle branch node menu items -->
            @if (item.children && item.children.length > 0) {
              <span>
                <button
                  (click)="onContextMenuAction($event)"
                  mat-menu-item
                  color="primary"
                  [matMenuTriggerFor]="menu.contextMenu"
                  >
                  <span>{{ item.caption }}</span>
                </button>
                <matContextMenu #menu [source]="item.children"></matContextMenu>
              </span>
            }
            <!-- Handle leaf node menu items -->
            @if (!item.children || item.children.length === 0) {
              <span>
                <button (click)="onContextMenuAction($event)" mat-menu-item>
                  <span>{{ item.caption }}</span>
                </button>
              </span>
            }
          </span>
        }
      </mat-menu>
    </span>`,
    standalone: false
})
export class MatContextMenuComponent implements AfterViewInit {
  @Input('source') source: any;
  @Input() id: string;
  @ViewChild(MatMenuTrigger, { static: false }) contextMenu: MatMenuTrigger;
  @Input() matMenuTriggerFor: MatMenuTrigger;
  @Output() myContextMenu = new EventEmitter();
  @ViewChild('childMenu') childMenu: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };
  firstExecution = true;
  firstExecutionAction = true;
  constructor(private contextMenuService: ContextMenuService) {}

  onContextMenu(event: any) {
    if (this.firstExecution === true) {
      event.preventDefault();
      this.contextMenu.closeMenu();
      this.contextMenuPosition.x = event.pageX + 'px';
      this.contextMenuPosition.y = event.pageY + 'px';
      this.contextMenu.openMenu();
      this.firstExecution = false;
    }
  }

  ngAfterViewInit() {
    this.contextMenu.closeMenu();
    this.contextMenuService.currentcontextMenuClick$.subscribe((event) => {
      this.contextMenu.closeMenu();
      this.onContextMenu(event);
    });
  }
  onContextMenuAction(event: any) {
    if (event && this.firstExecutionAction === true) {
      this.contextMenuService.changeMessage(event.target.innerText);
      this.firstExecutionAction = false;
    }
  }

  refrech() {}
}
